// @ts-nocheck
import styled from "@emotion/styled";
import { Switch } from "@mui/material";
import {
  getCssVariableHandler,
  getRGBAFromRGBGivenAlphaHandler,
} from "../../utils/styles/getCssVariables";

// export const CustomSwitch = styled((props) => (
//   <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
// ))(({ theme }) => ({
//   width: 42,
//   height: 26,
//   padding: 0,
//   "& .MuiSwitch-switchBase": {
//     padding: 0,
//     margin: 2,
//     transitionDuration: "300ms",
//     "&.Mui-checked": {
//       transform: "translateX(16px)",
//       color: "#fff",
//       "& + .MuiSwitch-track": {
//         backgroundColor: theme.palette.mode === "dark" ? "#D175B6" : "#D175B6",
//         opacity: 1,
//         border: 0,
//       },
//       "&.Mui-disabled + .MuiSwitch-track": {
//         opacity: 0.5,
//       },
//     },
//     "&.Mui-focusVisible .MuiSwitch-thumb": {
//       color: "#D175B6",
//       border: "6px solid #fff",
//     },
//     "&.Mui-disabled .MuiSwitch-thumb": {
//       color:
//         theme.palette.mode === "light"
//           ? theme.palette.grey[100]
//           : theme.palette.grey[600],
//     },
//     "&.Mui-disabled + .MuiSwitch-track": {
//       opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
//     },
//   },
//   "& .MuiSwitch-thumb": {
//     color: getRGBAFromRGBGivenAlphaHandler({
//       rgb: getCssVariableHandler({
//         variableName: "--bg-theme-rgb",
//       }),
//       alpha: "0.5",
//     }),
//     boxSizing: "border-box",
//     width: 22,
//     height: 22,
//   },
//   "& .MuiSwitch-track": {
//     borderRadius: 26 / 2,
//     backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
//     opacity: 1,
//     transition: theme.transitions.create(["background-color"], {
//       duration: 500,
//     }),
//   },
// }));

export const CustomSwitch = styled(({ slim, ...props }) => (
  // `slim` is a custom style-only prop: destructured HERE so it doesn't leak to
  // the <Switch>/DOM ("Received true for a non-boolean attribute slim"). The styleFn
  // below still receives `slim` (emotion passes the original props to it).
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme, slim, disabled }) => ({
  // Conditionally set dimensions based on the `slim` prop
  width: slim ? 36 : 42,
  height: slim ? 20 : 26,
  padding: 0,
  cursor: disabled ? "not-allowed" : "pointer",
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      // The translateX value remains the same because the relative movement is proportional.
      // Default: (width 42) - (thumb 22) - (margin 2*2) = 16px
      // Slim: (width 36) - (thumb 16) - (margin 2*2) = 16px
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.mode === "dark" ? "#D175B6" : "#D175B6",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#D175B6",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[300]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    color: getRGBAFromRGBGivenAlphaHandler({
      rgb: getCssVariableHandler({
        variableName: "--bg-theme-rgb",
      }),
      alpha: "0.5",
    }),
    boxSizing: "border-box",
    // Conditionally set thumb size
    width: slim ? 16 : 22,
    height: slim ? 16 : 22,
  },
  "& .MuiSwitch-track": {
    // The border radius should be half of the new height to maintain the pill shape
    borderRadius: (slim ? 20 : 26) / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));